import { Observable } from 'rxjs';

import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';

import { AuthFacade } from '@mitsubishi/core';
import { ApiUrlInjectionToken } from '@mitsubishi/shared/data-access';

import { Selection } from '../models';

@Injectable({
  providedIn: 'root',
})
export class PublicOfferService {
  private readonly baseUrl: string;
  private httpClient: HttpClient;
  #authFacade = inject(AuthFacade);

  headers = new HttpHeaders({
    'Accept-Language': this.#authFacade.userLanguage,
  });

  constructor(handler: HttpBackend, @Inject(ApiUrlInjectionToken) apiServerUrl: string) {
    this.httpClient = new HttpClient(handler);
    this.baseUrl = apiServerUrl;
  }

  getOffer(token: string): Observable<Selection> {
    return this.httpClient.get<Selection>(`${this.baseUrl}/offer/${token}`, { headers: this.headers });
  }

  shareOffer(token: string, languageCode: string, email: string[]): Observable<null> {
    return this.httpClient.post<null>(`${this.baseUrl}/offer/${token}/share?languageCode=${languageCode}`, { email });
  }

  sendNewToken(token: string, languageCode: string): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrl}/offer/${token}/refresh?languageCode=${languageCode}`, {});
  }

  downloadOfferPDF(token: string) {
    return this.httpClient.get(`${this.baseUrl}/offer/${token}/pdf`, { responseType: 'text' });
  }
}
